import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { ENUM_MODALS_VALUE, setModals } from "../../../../store/commonSlice";

import useTips from "../../../../hooks/useTips";
import useNickname from "../../../../hooks/site/useNickname";
import LovenseTip from "./LovenseTip";
import LovenseTipSpecial from "./LovenseTipSpecial";
import { ENUM_CHAT_TAB } from "../../../common/enums";
import { useAppSelector } from "../../../../store/index.ts";
import ChatSend from "../send/chat-send/ChatSend.jsx";

export default function ChatLovenseToys() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { postLovenseTips } = useTips();
  const { name } = useNickname();

  const levels = useAppSelector((state) => state.chat.lovense.tips.levels);
  const special = useAppSelector((state) => state.chat.lovense.tips.special);
  const balance = useAppSelector((state) => state.user.user.balance);

  const [chooseBtn, setChooseBtn] = useState(false);
  const [amount, setAmount] = useState();

  const tips = useMemo(() => {
    if (!levels) return [];

    const keys = Object.keys(levels);
    const tips = Object.values(levels)?.map((el, indx) => ({ id: keys[indx], ...el }));

    return tips;
  }, [levels]);

  const tipsSpecial = useMemo(() => {
    if (!special) return [];
    const keys = Object.keys(special);
    const tips = Object.values(special)
      ?.map((el, indx) => ({ id: keys[indx], type: keys[indx], ...el }))
      ?.filter((el) => el.enable !== false);

    return tips;
  }, [special]);

  const onChangeAmount = (e) => {
    setChooseBtn(false);
    const value = e.target.value;

    setAmount(value);
  };

  const onBtnClick = (e, tip) => {
    e?.stopPropagation?.();

    const showDepositModal = balance < tip.min || balance < tip.token || balance < tip.tokensBegin;

    if (showDepositModal) {
      dispatch(setModals({ name: ENUM_MODALS_VALUE.deposit, value: true }));
      return;
    }

    if (amount) {
      postLovenseTips({ amount, lovense: { id: tip.id, nickname: name } });
    }
  };

  const onTipItem = (tip) => {
    setChooseBtn((prev) => (prev === tip.id ? false : tip.id));

    if (tip.id === chooseBtn) return;

    const tipMax = tip.max || tip.tokensEnd;
    const max = tipMax == "infinity" ? 999 : tipMax;

    const amount = tip.token || max;

    setAmount(amount);
  };

  return (
    <>
      <div className="chat__tips__title">
        <span className="chat__tips__title__actmty">{t("DURATION")}</span>
        <span className="chat__tips__title__tokens">{t("VIBRATION")}</span>
        <span className="chat__tips__title__tokens">{t("TOKENS")}</span>
      </div>
      <div className="chat__toys">
        <div className="chat__tips__content">
          {tips.map((tip) => {
            return (
              <LovenseTip
                key={tip.id}
                tip={tip}
                chooseBtn={chooseBtn}
                onTipItem={onTipItem}
                onBtnClick={onBtnClick}
              />
            );
          })}

          {tipsSpecial.map((tip) => {
            return (
              <LovenseTipSpecial
                key={tip.id}
                tip={tip}
                chooseBtn={chooseBtn}
                onTipItem={onTipItem}
                onBtnClick={onBtnClick}
              />
            );
          })}
        </div>
      </div>
      <div className="chat__toys__send">
        <ChatSend
          tab={ENUM_CHAT_TAB.lovense}
          onChangeAmount={onChangeAmount}
          skipPlug
          sendPlug
          amount={amount}
          setCurrentToken={setAmount}
        />
      </div>
    </>
  );
}
